var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a36",
    x1: 9,
    y1: 16.795,
    x2: 9,
    y2: 1.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#639d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#6fb12a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#76bc2d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.083 8.438c0 4.571-5.626 8.25-6.85 9a.449.449 0 01-.466 0c-1.224-.747-6.85-4.426-6.85-9v-5.5a.44.44 0 01.434-.438C6.728 2.386 5.72.5 9 .5s2.272 1.886 6.649 2a.44.44 0 01.434.435z",
    fill: "#76bc2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.485c0 4.191-5.16 7.566-6.282 8.25a.412.412 0 01-.428 0c-1.126-.684-6.29-4.059-6.29-8.25V3.441a.4.4 0 01.4-.4C6.916 2.935 5.992 1.205 9 1.205s2.084 1.73 6.1 1.837a.4.4 0 01.4.4z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.853 7.66h-.408V6.243a2.652 2.652 0 00-.7-1.809 2.358 2.358 0 00-3.483 0 2.606 2.606 0 00-.7 1.808V7.66h-.415a.328.328 0 00-.326.32v3.682a.329.329 0 00.326.32h5.706a.329.329 0 00.326-.32V7.98a.328.328 0 00-.326-.32zm-1.549 0H7.7V6.219a1.434 1.434 0 01.41-.99 1.2 1.2 0 011.788 0 1.394 1.394 0 01.153.2 1.445 1.445 0 01.258.791z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.148 7.658h5.705a.328.328 0 01.21.08L5.938 11.9a.313.313 0 01-.116-.241v-3.68a.328.328 0 01.326-.321z",
    fill: "#b3b3b3",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.853 7.658H6.147a.328.328 0 00-.209.08l6.124 4.162a.314.314 0 00.117-.241v-3.68a.329.329 0 00-.326-.321z",
    fill: "#a3a3a3",
    opacity: 0.09
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSecurity);
export default __webpack_public_path__ + "static/media/azure-security.9222d5fb0c2931e80c8fd1c6246130bb.svg";
export { ForwardRef as ReactComponent };